<template>
	<div>
		<app-table
			class="mt-3"
			name="roles-access-modules"
			:columns="columns"
			:check-all="checkAll"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			selectable
			@on-page="changePage"
			@on-search-event="onSearch"
			@row-is-selected="rowIsSelected"
			@on-selected-all="allIsSelected"
		>
			<template slot="rows" slot-scope="props">
				<td>{{ props.row.name }}</td>
			</template>
		</app-table>
	</div>
</template>

<script>
function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

export default {
	name: 'role-access-module-list',
	props: {
		codeCompany: {
			type: String,
		},
		codeProject: {
			type: String,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		checkAll: {
			default: false,
			type: Boolean,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		allIsSelected,
		changePage,
		onSearch,
		rowIsSelected,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-access-module-list.vue